import { style } from '@vanilla-extract/css';
import { listContainer } from '@/components/highlighted-feed-wrapper/highlighted-feed-wrapper.css';

export const skeletonFeed = style([
  {
    display: 'flex',
    flexDirection: 'column',
  },
  listContainer,
]);
